import { useEffect, useRef, useState } from 'react';

function readWidth(node) {
  if (!node) return 0;
  const rectWidth = Number(node.getBoundingClientRect?.().width || 0);
  return Math.round(rectWidth || node.clientWidth || node.offsetWidth || 0);
}

export function useChartContainerWidth() {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const update = () => {
      const next = readWidth(node);
      if (next > 0) setWidth(next);
    };

    update();

    const resizeObserver =
      typeof ResizeObserver !== 'undefined' ? new ResizeObserver(() => update()) : null;
    resizeObserver?.observe(node);
    window.addEventListener('resize', update);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener('resize', update);
    };
  }, []);

  return { ref, width };
}
